import { useAuthState } from '@creditornot/wolt-auth/react';
import { useMemo } from 'react';

import { hasPermissions, usePermissions } from 'common/wolt-permissions';

const useUser = () => {
  const { user } = useAuthState();
  const permissions = usePermissions();
  const isEmployee = hasPermissions(
    [
      { resource: 'restaurant', operations: ['r'] },
      { resource: 'merchant', operations: ['r'] },
    ],
    permissions,
  );

  return useMemo(() => ({ isEmployee, user }), [isEmployee, user]);
};

export default useUser;
